// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__2KNFd","Logo":"Footer_Logo__FDTuY"};